// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container-arrow[data-v-51048b37]{-webkit-animation:toScroll-51048b37 1.5s infinite;animation:toScroll-51048b37 1.5s infinite}@-webkit-keyframes toScroll-51048b37{0%{transform:translateY(0)}to{transform:translateY(6px)}}@keyframes toScroll-51048b37{0%{transform:translateY(0)}to{transform:translateY(6px)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
